import React, { FC } from 'react'
import styled from 'styled-components'

import { Box } from '../../../../shared_components/UI/Box'

const Container = styled(Box)`
  border-bottom: 1px solid #e5e5e522;
  flex: 1;
  width: 100%;
  padding: 16px 0;
  position: relative;
  min-width: 760px;
  @media screen and (max-width: 767px) {
    min-width: 80vw;
  }
`

const Avatar = styled.img`
  border-radius: 250px;
  width: 80px;
  height: 80px;
  margin-right: 16px;
  flex: 0;
`

const TextBlock = styled(Box)`
  width: 100%;
`

const Name = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 26px;

  text-transform: uppercase;
`

const Position = styled(Name)`
  opacity: 0.6;
`

const SocialLink = styled.a`
  height: 16px;
  color: ${({ theme }) => (theme.isDark ? 'white' : '#333')};
  margin-left: 16px;
  path {
    transition: 0.3s ease-in-out;
  }
  :hover {
    path {
      fill: ${(props) => props.theme.colors.brandPrimary}!important;
    }
  }
  img {
    height: 16px;
  }
`

const Icons = styled(Box)`
  justify-self: flex-end;
  justify-content: flex-end;
  @media screen and (max-width: 767px) {
    margin-right: 8px;
  }
`

interface Links {
  link?: any
}

const Member: FC<{ member?: any }> = ({ member }) => {
  const { name, position, links, avatar } = member

  if (!member) return <></>

  return (
    <Container align="center">
      <Avatar src={avatar?.url} />
      <TextBlock direction="column" flex={1}>
        <Name>{name}</Name>
        <Position>{position}</Position>
      </TextBlock>
      <Icons>
        {links.map((linkObj: Links) => {
          const { link } = linkObj
          if (!link) return <></>
          const platform =
            link.toString().split('https://')[1].split('.')[0] === 'www'
              ? link.toString().split('https://')[1].split('.')[1]
              : link.toString().split('https://')[1].split('.')[0]

          return (
            <SocialLink
              href={link}
              target="_blank"
              rel="noreferrer"
              key={`social-link-${new Date().getTime() * Math.random()}`}
            >
              <img
                src={`/img/icons/${
                  platform === 'twitter' ? 'x' : platform
                }.svg`}
                alt={platform}
              />
            </SocialLink>
          )
        })}
      </Icons>
    </Container>
  )
}

export default Member
